import { CSSProperties, ReactNode, useMemo } from "react";
import { classNames } from "@ct-react/core";
import { Wrapper } from "../wrapper";
import "./page-foot.scss";

type Props = {
  className?: string;
  background: string;
  children: ReactNode;
}

const PageFoot = ({ className, background, children }: Props) => {

  const styleProperties = useMemo(() => ({
    "--ccv-foot-bg-image": `url(${background})`
  } as CSSProperties), [ background ]);

  const wrapperClasses = classNames("page-foot", className);

  return (
    <section className={wrapperClasses}>
      <Wrapper.Centered>
        <div className="picture" style={styleProperties} />
        <div className="inner-wrap">{children}</div>
      </Wrapper.Centered>
    </section>);

}

export default PageFoot;
